import labels from 'constants/labels';
import React from 'react';

function FeedbackIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testId={labels.header.feedback}
    >
      <path
        d="M6.25 13.75H13.75V12.25H6.25V13.75ZM6.25 10.75H17.75V9.25H6.25V10.75ZM6.25 7.75H17.75V6.25H6.25V7.75ZM2.5 21.05V4.3C2.5 3.8 2.675 3.375 3.025 3.025C3.375 2.675 3.8 2.5 4.3 2.5H19.7C20.2 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.8 21.5 4.3V15.7C21.5 16.2 21.325 16.625 20.975 16.975C20.625 17.325 20.2 17.5 19.7 17.5H6.05L2.5 21.05ZM4 17.425L5.425 16H19.7C19.7833 16 19.8543 15.9707 19.913 15.912C19.971 15.854 20 15.7833 20 15.7V4.3C20 4.21667 19.971 4.14567 19.913 4.087C19.8543 4.029 19.7833 4 19.7 4H4.3C4.21667 4 4.146 4.029 4.088 4.087C4.02933 4.14567 4 4.21667 4 4.3V17.425ZM4 4.3C4 4.21667 4 4.14567 4 4.087C4 4.029 4 4 4 4C4 4 4 4.029 4 4.087C4 4.14567 4 4.21667 4 4.3V15.7C4 15.7833 4 15.854 4 15.912C4 15.9707 4 16 4 16V17.425V4.3Z"
        fill="#303641"
      />
    </svg>
  );
}

export default FeedbackIcon;
